import Base from './action-base'
import renderFields from './finish-playbook.pug'

export default class FinishPlaybook extends Base
  Object.defineProperty this, "label", get: -> @t(".label")
  @icon = "fa-flag-checkered"

  @DEFAULTS:
    names: []

  renderFields: renderFields

